(function () {
  function tryPlay(video) {
    if (!video || video.tagName !== 'VIDEO') return;
    video.muted = true;
    video.defaultMuted = true;
    video.setAttribute('muted', '');
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
    video.loop = true;

    var promise = video.play();
    if (promise && typeof promise.catch === 'function') {
      promise.catch(function () {});
    }
  }

  function tryPause(video) {
    if (!video || video.tagName !== 'VIDEO') return;
    if (!video.paused) video.pause();
  }

  function hydrateYoutube(iframe) {
    if (!iframe || iframe.getAttribute('src')) return;
    var src = iframe.getAttribute('data-src');
    if (!src) return;
    iframe.setAttribute('src', src);
    iframe.removeAttribute('data-src');

    iframe.addEventListener(
      'load',
      function () {
        var poster = iframe.previousElementSibling;
        if (poster && poster.classList.contains('zaoud-vp__poster')) {
          poster.classList.add('is-hidden');
        }
      },
      { once: true }
    );
  }

  function observeMedia(el, onEnter, onLeave) {
    if (!('IntersectionObserver' in window)) {
      onEnter();
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) onEnter();
          else if (typeof onLeave === 'function') onLeave();
        });
      },
      { rootMargin: '120px 0px', threshold: 0.15 }
    );
    observer.observe(el);
  }

  function initVideos(root) {
    root.querySelectorAll('.zaoud-vp__video').forEach(function (video) {
      video.setAttribute('preload', 'none');

      observeMedia(
        video,
        function () {
          if (video.dataset.zaoudVpReady !== 'true') {
            video.dataset.zaoudVpReady = 'true';
            video.preload = 'metadata';
            video.addEventListener('loadeddata', function () {
              tryPlay(video);
            }, { once: true });
          }
          tryPlay(video);
        },
        function () {
          tryPause(video);
        }
      );
    });

    root.querySelectorAll('[data-zaoud-vp-youtube]').forEach(function (iframe) {
      observeMedia(iframe, function () {
        hydrateYoutube(iframe);
      });
    });
  }

  if (!customElements.get('zaoud-video-product')) {
    class ZaoudVideoProduct extends HTMLElement {
      connectedCallback() {
        if (this.dataset.zaoudVpInit === 'true') return;
        this.dataset.zaoudVpInit = 'true';

        initVideos(this);

        this.panels = Array.from(this.querySelectorAll('[data-zaoud-vp-panel]'));
        this.railButtons = Array.from(this.querySelectorAll('[data-zaoud-vp-rail-btn]'));

        this.onActivate = this.onActivate.bind(this);
        this.railButtons.forEach(function (btn) {
          btn.addEventListener('click', this.onActivate);
        }, this);

        document.addEventListener('shopify:block:select', this.onBlockSelect);
        document.addEventListener('shopify:section:load', this.onSectionLoad);
      }

      disconnectedCallback() {
        this.railButtons.forEach(function (btn) {
          btn.removeEventListener('click', this.onActivate);
        }, this);
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
        document.removeEventListener('shopify:section:load', this.onSectionLoad);
      }

      onSectionLoad = function (event) {
        var root = event.target.querySelector('[data-zaoud-vp]');
        if (root) initVideos(root);
      };

      onBlockSelect = function (event) {
        if (!this.contains(event.target)) return;
        var panel = event.target.closest('[data-zaoud-vp-panel]');
        var id = panel && panel.dataset.productId;
        if (id) this.activate(id, { scrollRail: true });
      };

      onActivate(event) {
        var id = event.currentTarget && event.currentTarget.dataset.productId;
        if (!id) return;
        this.activate(id, { scrollRail: true });
      }

      activate(id, options) {
        var opts = options || {};

        this.panels.forEach(function (panel) {
          var active = panel.dataset.productId === id;
          panel.classList.toggle('is-active', active);
          if (active) {
            panel.removeAttribute('hidden');
          } else {
            panel.setAttribute('hidden', '');
          }
        });

        this.railButtons.forEach(function (btn) {
          var active = btn.dataset.productId === id;
          btn.classList.toggle('is-active', active);
          if (active && opts.scrollRail) {
            btn.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
          }
        });
      }
    }

    customElements.define('zaoud-video-product', ZaoudVideoProduct);
  } else {
    document.querySelectorAll('[data-zaoud-vp]').forEach(initVideos);
  }
})();
